<template>
  <div class="about">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-xlarge-size-70 md-large-size-70 md-small-size-90 ql-editor articleContent"
        v-html="getMyDataContent.content"
      ></div>
      <div class="md-layout-item md-layout md-size-70 md-alignment-center">
        <a :href="getMyDataContent.fb" target="_blank">
          <img src="../assets/fb.png" class="icons md-layout-item-20" />
        </a>
        <a :href="getMyDataContent.insta" target="_blank">
          <img
            src="../assets/insta.png"
            class="icons md-layout-item-20"
            :href="getMyDataContent.insta"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// @ is an alias to /src

export default {
  name: "me",
  components: {},
  computed: {
    ...mapGetters(["getMyDataContent"])
  }
};
</script>

<style >
.home {
}

.fullHeight {
  height: 88vh;
}
.mePic {
}
.textWrap {
  max-height: 150px;
  float: left;
  margin-right: 15px;
  margin-bottom: 15px;
}

.meText {
  font-size: 25px;
  text-align: justify;
  line-height: 35px;
  margin: 0;
}

.paddin {
  padding-left: 50px;
  padding-right: 50px;
}

.icons {
  width: 50px;
  border-radius: 10px;
  margin: 20px;
}

.icons:hover {
  cursor: pointer;
}
</style>
